import { SupabaseDeadlineRuleService } from './supabase/supabaseDeadlineRuleService';
import { DeadlineRuleType } from '../types';

// シンプルなファサード関数群（テスト容易性のため関数として公開）
export async function getDeadlineRulesByBusinessPartnerId(
  businessPartnerId: string,
  companyId?: string
) {
  const svc = new SupabaseDeadlineRuleService();
  return svc.getDeadlineRulesByBusinessPartnerId(businessPartnerId, companyId);
}

export async function checkDeadlineViolation(
  businessPartnerId: string,
  businessPartnerName: string,
  ruleType: DeadlineRuleType,
  scheduledDateTime: string,
  companyId: string
) {
  const svc = new SupabaseDeadlineRuleService();
  return svc.checkDeadlineViolation(
    businessPartnerId,
    businessPartnerName,
    ruleType,
    scheduledDateTime,
    companyId
  );
}
